<template>
  <div
    v-if="device_vender !== 'NEXCO-A' && data.featureStatus.mov"
    class="card theme"
  >
    <div class="step-nav">
      <button class="move-back" @click="goPrev">
        <i class="material-icons">arrow_back_ios</i>
      </button>
    </div>
    <div class="header">
      <h2 v-text="`1. ${$t('mov_making.mov_title1')}`"></h2>
      <p class="information" v-html="$t('mov_making.desc_select_theme')"></p>
    </div>
    <div class="body">
      <div class="function-box">
        <div v-if="access_type === 'web'" class="search">
          <input
            id="searchBox"
            type="text"
            :placeholder="$t('common.t_input_search')"
            @keyup.enter="searchEvent"
          />
        </div>
        <div v-if="access_type === 'web'" class="buttons">
          <button
            type="button"
            class="button primary"
            @click.prevent="openCategoryPopup()"
          >
            <img src="@assets/images/icon-pad-menu.png" alt="Icon menu" />
            <span v-text="$t('mov_making.condition_search')"></span>
          </button>
          <select id="listPer" @change="changeListPer">
            <option value="10" v-text="`10${$t('common.t_s_unit')}`"></option>
            <option value="20" v-text="`20${$t('common.t_s_unit')}`"></option>
            <option value="50" v-text="`50${$t('common.t_s_unit')}`"></option>
          </select>
        </div>
      </div>
      <div class="list-box">
        <ul>
          <li id="dataNoExist" style="display: none">
            <div class="theme-item">
              <p v-text="$t('common.t_no_exist_theme')"></p>
            </div>
          </li>
          <li v-for="(item, idx) in data.list" :key="idx">
            <div class="theme-item">
              <div class="image-box">
                <img
                  :src="item.thumb_url"
                  alt="Theme Image"
                  @click.prevent="setShowingPreviewTheme(item)"
                />
              </div>
              <div class="content-box">
                <div class="data-line">
                  <h2 v-text="item.title"></h2>
                </div>
                <div class="data-line">
                  <p v-text="item.category"></p>
                </div>
                <div class="data-line dual">
                  <p v-text="item.date"></p>
                  <button
                    class="button primary"
                    @click.prevent="
                      onNextBtn(
                        item.id,
                        item.category,
                        item.category_id,
                        item.time,
                        item.date,
                        item.title,
                      )
                    "
                    v-text="$t('movie_list.sub_btn_select')"
                  ></button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="page-box">
        <Pagination
          v-model="selectedPage"
          :pageCount="pageCount"
          :pageRange="5"
          :pageClass="'page-item'"
          :containerClass="'pagination'"
          :prevText="'<'"
          :nextText="'>'"
          :firstLastButton="false"
          :clickHandler="pagingCallback"
        ></Pagination>
      </div>
    </div>
    <PopupThemePreview
      v-if="access_type === 'web'"
      :opened="isThemePreviewOpened"
      :previewVideoPath="previewVideoPath"
      @hideThemePopup="closeThemePopup"
    />
    <PopupCategory
      v-if="isCategoryPopup"
      :checkedCategories="data.categories"
      @hideCategoryPopup="closeCategoryPopup"
      @confirmCategory="confirmCategory"
    />
    <PopupSpinner :opened="isPopOpend" @popupOff="spinnerOpend" />
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import JSZip from 'jszip';
import Pagination from 'vuejs-paginate';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import userInfo from '@src/mixins/userInfo';
import EventBus from '@utils/bus';
import Utils from '@action/util';
import ListUtils from '@action/list_utils';
import api from '@api/index';
import videoData from '@api/video';
import PopupThemePreview from '@src/components/theme/PopupThemePreview';
import PopupSpinner from '@components/PopupSpinner.vue';
import PopupCategory from '@components/theme/PopupCategory';

const data = {
  list: [],
  list_cnt: 0,
  list_pagination: {
    isPrev: false,
    isNext: false,
    pages: [],
    page: 1,
    pageTotal: 0,
  },
  list_search: { title: eve.Lang.t('common.t_search') },
  categories: [],
  isCheck: false,
  product_type_id: '',
  data_search_bar: {
    id: 'drop2',
    list_drop_count: [10, 50, 100],
    count_drop: 10,
    title: eve.Lang.t('common.t_input_search'),
    search_text: '',
    is_help: true,
    is_searching: false,
    is_show_search: true,
    is_show_per: true,
  },
  role_code: sessionStorage.getItem('role_code'),
  img_list: [],
  img_cnt: 0,
  feature: {},
  featureStatus: {},
};

export default {
  name: 'theme',
  head: {
    title: {
      inner: 'Theme',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Theme Of Smart Solution',
      },
    ],
  },
  mixins: [userInfo],
  components: {
    Pagination,
    PopupSpinner,
    PopupThemePreview,
    PopupCategory,
  },
  computed: {
    pageCount() {
      return data.list_pagination.pageTotal ?? 1;
    },
  },
  data() {
    return {
      isThemePreviewOpened: false,
      isCategoryPopup: false,
      previewTheme: '',
      data,
      access_type: '',
      isPopOpend: false,
      ListUtils,
      pageData: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 },
        { id: 6 },
        { id: 7 },
        { id: 8 },
        { id: 9 },
        { id: 10 },
        { id: 11 },
      ],
      selectedPage: 1,
      device_vender: '',
      previewThemeId: 0,
      previewVideoPath: '',
    };
  },
  created() {
    videoData.data.is_view_control = true;
    data.product_type_id = videoData.data.product_type_id;
    data.list_pagination.page = 1;
    data.categories = [];
    this.access_type = sessionStorage.getItem('access_type');

    if (!this.access_type) {
      this.access_type = this.$route.query.access_type;
    }

    this.receiveEventInit();
  },
  destroyed() {
    EventBus.$off('is-opend');
  },
  methods: {
    receiveEventInit() {
      EventBus.$on('is-opend', () => {
        this.isPopOpend = false;
      });
    },
    async serverRequest(
      searchColumn = ListUtils.SEARCH_COLUMN,
      productTypeId = data.product_type_id,
    ) {
      const searchText = document.getElementById('searchBox')?.value;
      const listPer = document.querySelector('#listPer option:checked')?.value;
      const categories = _.size(data.categories) ? data.categories : undefined;
      ListUtils.SEARCH_NAME = searchText || '';
      ListUtils.PAGE = data.list_pagination.page;
      ListUtils.LIST_PER = listPer || 10;
      ListUtils.CATEGORIES = categories;

      this.spinnerOpend();

      await this.$store.dispatch('API_THEME', {
        data: {
          page: ListUtils.PAGE,
          length: ListUtils.LIST_PER,
          search_column: ListUtils.SEARCH_NAME !== '' ? searchColumn : '',
          search_value: ListUtils.SEARCH_NAME,
          categories: ListUtils.CATEGORIES,
          product_type_id: productTypeId,
          user_id:
            videoData.role_code === '12006' ? videoData.user_id : undefined,
        },
        cb: this.callback,
      });
    },
    async callback(obj) {
      data.list = [];
      data.list_cnt = 0;

      if (!_.size(obj.items)) {
        data.list_pagination.pageTotal = 1;
        this.spinnerOpend();
        document.getElementById('dataNoExist').style.display = 'block';
      } else {
        document.getElementById('dataNoExist').style.display = 'none';
        const paginationData = obj.pagination;
        const { total_count: totalCount, page } = paginationData;
        const per = _.size(paginationData);
        const pageDirect = ListUtils.control(page, per, totalCount);
        data.list_pagination.isPrev = pageDirect.prev;
        data.list_pagination.isNext = pageDirect.next;
        data.list_pagination.pageTotal = pageDirect.pageTotal;

        // pagination
        data.list_pagination.pages = ListUtils.getPagination();
        data.list_pagination.page = page;

        if (ListUtils.PAGE !== 10) {
          data.list_pagination.page = ListUtils.PAGE;
        } else {
          data.list_pagination.page = page;
        }

        const dataList = _.map(obj.items, async (item = {}) => {
          const thumb = await api.video.themeViewThumbnail(item.id);
          const thumbURL = `data:image/png;base64,${Utils.convertArrayBufferToBase64(
            thumb.data,
          )}`;
          data.list_cnt += 1;
          return {
            num: data.list_cnt,
            thumb_url: thumbURL,
            id: item.id,
            category_id: item.category_id,
            title: item.title,
            category: item.category_name,
            time: Utils.milToSec(item.time) + eve.Lang.t('sec'),
            date: moment
              .utc(item.register_datetime)
              .local()
              .format('YYYY.MM.DD hh:mm'),
          };
        });
        data.list = await Promise.all(dataList);
        this.spinnerOpend();
        document.querySelector('.body').style.display = 'block';
      }
    },
    setSelectedPage(page) {
      data.list_pagination.page = page;
      this.selectedPage = page;
    },
    changeListPer() {
      this.setSelectedPage(1);
      this.serverRequest('all', data.product_type_id);
    },
    userInfoCallback(obj) {
      this.access_type = obj.access_type;
      data.product_type_id = obj.product_type_id;
      data.feature = obj.feature;
      data.featureStatus = obj.featureStatus;

      if (
        (this.access_type === 'web' || sessionStorage.accessToken) &&
        this.device_vender !== 'NEXCO-A'
      ) {
        this.serverRequest('all', data.product_type_id);
      }
    },
    async pagingCallback(num) {
      data.list_pagination.page = num;
      await this.serverRequest('all', data.product_type_id);
      window.scrollTo(0, 0);
    },
    async getThemeImage({ theme, productTypeId }) {
      const themeImage = await import(
        `@assets/images/themes/${theme}/${productTypeId}.jpg`
      );
      const imageURL = themeImage.default;

      if (imageURL.match(Utils.dataUriRegex())) {
        return imageURL;
      }

      const image = new Image();
      image.src = imageURL;
      const dataURL = await new Promise((resolve) => {
        image.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = image.width;
          canvas.height = image.height;
          const context = canvas.getContext('2d');
          context.drawImage(image, 0, 0);
          resolve(canvas.toDataURL('image/jpeg'));
        };
      });

      return dataURL;
    },
    async onNextBtn(themeId, categoryName, categoryId, time, date, title) {
      data.img_list = {};

      this.spinnerOpend();

      if (title === 'black') {
        data.img_list['video1.jpg'] = await this.getThemeImage({
          theme: 'black',
          productTypeId: data.product_type_id,
        });
        EventBus.$emit('childs-event', {
          type: Common.EVT_CB_SCREEN_TYPE,
          screen_type: 'effect',
          data: {
            product_type_id: data.product_type_id,
            img_list: data.img_list,
            theme_id: themeId,
            step_type: 'theme',
            cat_name: categoryName,
            cat_id: categoryId,
            reg_date: date,
            encoding_type: 'image',
            time,
            title,
          },
        });
      } else {
        this.$store.dispatch('IMG_SERVER_REQUEST', {
          data: themeId,
          user_id:
            videoData.role_code === '12006' ? videoData.user_id : undefined,
          cb(obj) {
            const byteLimit = 20000;

            if (byteLimit > obj.byteLength) {
              alert(Lang.t('common.d_file_mov_error'));
              return;
            }

            const zip = new JSZip();
            let cnt = 0;
            zip.loadAsync(obj.data).then((zipData) => {
              zipData.forEach((relativePath, zipEntry) => {
                zipEntry.async('arraybuffer').then((content) => {
                  cnt += 1;

                  data.img_list[
                    `video${relativePath}`
                  ] = `data:image/jpg;base64,${Utils.convertArrayBufferToBase64(
                    content,
                  )}`;

                  if (cnt === _.size(zipData.files)) {
                    EventBus.$emit('childs-event', {
                      type: Common.EVT_CB_SCREEN_TYPE,
                      screen_type: 'effect',
                      data: {
                        product_type_id: data.product_type_id,
                        img_list: data.img_list,
                        theme_id: themeId,
                        step_type: 'theme',
                        cat_name: categoryName,
                        cat_id: categoryId,
                        reg_date: date,
                        time,
                        title,
                      },
                    });
                  }
                });
              });
            });
          },
        });
      }
    },
    searchEvent() {
      const text = document.getElementById('searchBox').value;
      ListUtils.search(text);
      this.setSelectedPage(1);
      this.serverRequest('all', data.product_type_id);
    },
    resetVideoPath() {
      this.previewVideoPath = '';
      this.previewThemeId = 0;
    },
    async setShowingPreviewTheme(theme) {
      this.isThemePreviewOpened = true;
      this.resetVideoPath();
      this.previewVideoPath = await this.getVideoPath(theme.id);
      this.previewThemeId = theme.id;
    },
    async getVideoPath(themeId) {
      const response = await this.$store.dispatch('THEME_PREVIEW', themeId);

      if (!response.data) {
        alert(this.$t('user.server_error'));
        this.closeThemePopup();
        return '';
      }

      return `data:video/mp4;base64,${Utils.convertArrayBufferToBase64(
        response.data,
      )}`;
    },
    closeThemePopup() {
      this.isThemePreviewOpened = false;
    },
    closeCategoryPopup() {
      this.isCategoryPopup = false;
    },
    openCategoryPopup() {
      this.isCategoryPopup = true;
    },
    confirmCategory(arrCate) {
      this.data.categories = arrCate;
      this.setSelectedPage(1);
      this.serverRequest('all', data.product_type_id);
    },
    spinnerOpend() {
      this.isPopOpend = !this.isPopOpend;
    },
    goPrev(type) {
      EventBus.$emit('move-back', type);
    },
  },
};
</script>

<style scoped lang="scss">
.card.theme {
  width: 100%;
  padding: 24px;
  background-color: $white;
  position: relative;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

  .header {
    h2 {
      font-size: 24px;
    }

    .information {
      margin-top: 6px;
      font-size: 12px;
      color: $gray-33;
      line-height: 1.5em;
    }
  }

  @media (max-width: 480px) {
    .header {
      h2 {
        font-size: 18px;
      }

      .information {
        font-size: 11px;
      }
    }
  }

  .body {
    display: none;
    margin-top: 20px;
    background-color: $white;

    .function-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .search {
        input {
          padding-right: 36px;
          background-image: url(~@assets/images/icon-search.png);
          background-repeat: no-repeat;
          background-position: center right 12px;
          background-size: 12px;
        }
      }

      .buttons {
        min-width: 240px;
        display: flex;
        align-items: center;

        button,
        select {
          width: 50%;
          height: 30px;
        }

        button {
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 12px;
          }

          span {
            margin-left: 6px;
          }
        }

        select {
          margin-left: 12px;
        }
      }
    }

    @media (max-width: 640px) {
      .function-box {
        display: block;

        .buttons {
          margin-top: 12px;
        }
      }
    }

    .tab-box {
      width: 100%;
      height: 32px;
      margin-top: 12px;
      overflow-x: auto;
      overflow-y: hidden;

      ul {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        li {
          width: 100%;
          min-width: 72px;
          height: 100%;
          border-bottom: 1px solid $gray-eb;
          display: flex;
          align-items: center;
          justify-content: center;

          &.on {
            border-bottom: 1px solid $primary;
          }
        }
      }
    }

    #dataNoExist {
      border: 1px solid $gray-eb;
      padding-left: 10px;

      p {
        padding-top: 15px;
        text-align: center;
        font-size: 15px;
        font-weight: bold;
      }
    }

    .list-box {
      ul {
        width: 100%;
        flex-direction: column;

        li {
          width: 100%;
          border-bottom: 1px solid $gray-eb;

          .theme-item {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;

            &:first-child,
            &:nth-child(2) {
              border-top: 1px solid $gray-eb;
            }

            h3 {
              color: #888;
            }

            .image-box {
              overflow: hidden;
              position: relative;
              width: 40%;
              height: 100%;

              img {
                width: 100%;
                height: 100%;
                min-width: 100%;
                min-height: 100%;
                object-fit: contain;
              }
            }

            .content-box {
              width: 60%;
              padding-left: 6px;

              .data-line {
                display: flex;
                align-items: center;
                margin-left: 10px;

                &.dual {
                  justify-content: space-between;
                }

                h2 {
                  font-size: 13px;
                  height: 2.5em;
                }

                label {
                  width: 36px;
                }

                p {
                  margin-top: 4px;
                  font-size: 11px;

                  &.title {
                    height: 3.6em;
                  }
                }

                button {
                  margin-top: 4px;
                  width: 48px;
                  height: 24px;
                  padding: 0;
                  -webkit-border-radius: 3px;
                  -moz-border-radius: 3px;
                  border-radius: 3px;
                  font-size: 12px;
                }
              }

              @media (max-width: 360px) {
              }
            }
          }
        }
      }
    }

    .page-box {
      width: 100%;
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

@media (max-width: 480px) {
  .card.theme {
    margin-top: 10px;
    padding: 12px;
  }
}
</style>
